import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const STYLES = {
  New: "bg-purple-500/10 text-purple-600 dark:text-purple-400 border-purple-500/20",
  "With Karigar": "bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/20",
  Ready: "bg-orange-500/10 text-orange-600 dark:text-orange-400 border-orange-500/20",
  "In Shop": "bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 border-indigo-500/20",
  Delivered: "bg-green-500/10 text-green-600 dark:text-green-400 border-green-500/20",
  Cancelled: "bg-red-500/10 text-red-600 dark:text-red-400 border-red-500/20",
  Paid: "bg-green-500/10 text-green-600 dark:text-green-400 border-green-500/20",
  Partial: "bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/20",
  Pending: "bg-red-500/10 text-red-600 dark:text-red-400 border-red-500/20",
  Available: "bg-green-500/10 text-green-600 dark:text-green-400 border-green-500/20",
  Reserved: "bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/20",
  Sold: "bg-zinc-500/10 text-zinc-600 dark:text-zinc-400 border-zinc-500/20",
  Completed: "bg-green-500/10 text-green-600 dark:text-green-400 border-green-500/20",
  "In Progress": "bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 border-indigo-500/20",
};

export const StatusBadge = ({ status, className }) => (
  <Badge
    variant="outline"
    data-testid={`status-badge-${String(status).toLowerCase().replace(/\s+/g, "-")}`}
    className={cn("rounded-full font-medium border", STYLES[status] || "bg-muted text-muted-foreground", className)}
  >
    {status}
  </Badge>
);
